import { FC, useMemo } from 'react'
import { createFloatingPaneByTypeSelector } from 'selectors/floatingPanesSelectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'

import {
  CRYPTO_REWARDS_SELL_MODE_STEP_CRYPTO_WALLET,
  CRYPTO_REWARDS_SELL_MODE_STEP_SELL_AMOUNT,
  CRYPTO_REWARDS_SELL_MODE_STEP_PREVIEW_ORDER,
  CRYPTO_REWARDS_SELL_MODE_STEP_PENDING,
  CRYPTO_REWARDS_SELL_MODE_STEP_SUCCESS,
  CRYPTO_REWARDS_SELL_MODE_STEP_LOADING,
} from 'components/features/rewards/rewardsPane/constants/paneSteps'
import { FLOATING_PANE_CRYPTO_REWARDS_PANE_TYPE, FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE } from 'components/features/rewards/rewardsPane/constants/paneState'
import { CryptoRewardsPane } from 'components/features/rewards/rewardsPane/types/paneState'
import {
  CryptoRewardsSellCryptoWalletStep,
} from 'components/features/rewards/rewardsPane/containers/CryptoRewardsSellPane/CryptoRewardsSellCryptoWalletStep/CryptoRewardsSellCryptoWalletStep'
import {
  CryptoRewardsSellModeSellAmountStep,
} from 'components/features/rewards/rewardsPane/containers/CryptoRewardsSellPane/CryptoRewardsSellModeSellAmountStep/CryptoRewardsSellModeSellAmountStep'
import {
  CryptoRewardsSellPreviewOrderStep,
} from 'components/features/rewards/rewardsPane/containers/CryptoRewardsSellPane/CryptoRewardsSellPreviewOrderStep/CryptoRewardsSellPreviewOrderStep'
import {
  CryptoRewardsSellSendingOrderStep,
} from 'components/features/rewards/rewardsPane/containers/CryptoRewardsSellPane/CryptoRewardsSellPendingStep/CryptoRewardsSellPendingStep'
import {
  CryptoRewardsSellSuccessStep,
} from 'components/features/rewards/rewardsPane/containers/CryptoRewardsSellPane/CryptoRewardsSellSuccessStep/CryptoRewardsSellSuccessStep'
import { LoadingPane } from 'components/features/rewards/rewardsPane/containers/CryptoRewardsSellPane/LoadingPane/LoadingPane'

type CryptoRewardsSellPaneProps = {
  onClose: () => void
}
export const CryptoRewardsSellPane: FC<CryptoRewardsSellPaneProps> = ({ onClose }) => {
  const paneSelector = useMemo(createFloatingPaneByTypeSelector, [])
  const paneState = useStoreSelector((state) => paneSelector(state, FLOATING_PANE_CRYPTO_REWARDS_PANE_TYPE)) as Extract<CryptoRewardsPane, { mode: typeof FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE }> | null

  if (!paneState) {
    return null
  }

  switch (paneState.step) {
    case CRYPTO_REWARDS_SELL_MODE_STEP_LOADING:
      return (
        <LoadingPane onClose={ onClose } />
      )
    case CRYPTO_REWARDS_SELL_MODE_STEP_CRYPTO_WALLET:
      return (
        <CryptoRewardsSellCryptoWalletStep onClose={ onClose } />
      )
    case CRYPTO_REWARDS_SELL_MODE_STEP_SELL_AMOUNT:
      return <CryptoRewardsSellModeSellAmountStep onClose={ onClose } />
    case CRYPTO_REWARDS_SELL_MODE_STEP_PREVIEW_ORDER:
      return <CryptoRewardsSellPreviewOrderStep onClose={ onClose } />
    case CRYPTO_REWARDS_SELL_MODE_STEP_PENDING:
      return <CryptoRewardsSellSendingOrderStep onClose={ onClose } />
    case CRYPTO_REWARDS_SELL_MODE_STEP_SUCCESS:
      return <CryptoRewardsSellSuccessStep onClose={ onClose } />
  }

  return null
}
